import {
  QuestionCircleOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Popover,
  Radio,
  Row,
} from "antd";

import {
  Title,
  SubText,
  ContentContainer,
  MyCaseSection,
  Container,
  CaseDetailWrapper,
} from "../../../Form.style";

import { useEffect } from "react";

const Step1 = ({ data, setData, onNext, itemLayout }) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    setData(values);
    onNext();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container style={{ textAlign: "left" }}>
      <MyCaseSection>
        <ContentContainer>
          <Title>점유이전금지 가처분 사유</Title>

          <div style={{ marginTop: 10 }}>
            <SubText style={{ textAlign: "left" }} type="secondary">
              가처분 신청의 사유와 상황을 작성해주세요.
            </SubText>
          </div>

          <Divider style={{ marginTop: 10 }} />
          <CaseDetailWrapper>
            <Form
              {...itemLayout.form}
              layout="horizontal"
              onFinish={onFinish}
              initialValues={data}
              form={form}
              style={{
                marginTop: 10,
                marginBottom: 20,
                width: "100%",
                textAlign: "left",
              }}
              requiredMark={false}
            >
              <Form.Item
                label="가처분 사유"
                name={["injunction", "reason"]}
                rules={[
                  {
                    required: true,
                    message: "가처분 사유를 선택해주세요",
                  },
                ]}
              >
                <Checkbox.Group style={{ width: "100%" }}>
                  <Row>
                    <Col span={12}>
                      <Checkbox value="occupant_change">
                        점유자 변경 우려
                      </Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="sublease">
                        무단 전대 우려
                      </Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="third_party">
                        제3자 점유 중
                      </Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="eviction_prep">
                        명도소송 준비 중
                      </Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="etc">기타</Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Form.Item>

              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) => {
                  return (
                    JSON.stringify(prevValues.injunction?.reason) !==
                    JSON.stringify(currentValues.injunction?.reason)
                  );
                }}
              >
                {() => {
                  const reasons = form.getFieldValue(["injunction", "reason"]) || [];
                  return reasons.includes("etc") ? (
                    <Form.Item
                      label="기타 사유"
                      name={["injunction", "reasonEtc"]}
                      rules={[
                        {
                          required: true,
                          message: "기타 사유를 입력해주세요",
                        },
                      ]}
                    >
                      <Input placeholder="기타 사유를 입력하세요" />
                    </Form.Item>
                  ) : null;
                }}
              </Form.Item>

              <Form.Item
                label={
                  <>
                    현재 점유자 정보
                    <Popover
                      content={
                        <div>
                          현재 해당 부동산을 점유하고 있는 사람의
                          <br />
                          이름과 관계를 알려주세요.
                        </div>
                      }
                      placement="bottom"
                      trigger="click"
                    >
                      <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                    </Popover>
                  </>
                }
                name={["injunction", "occupantInfo"]}
                rules={[
                  {
                    required: true,
                    message: "현재 점유자 정보를 입력해주세요",
                  },
                ]}
              >
                <Input placeholder="예: 임차인 홍길동 / 제3자 김철수 (전대차)" />
              </Form.Item>

              <Form.Item
                label="대상 부동산 주소"
                name={["injunction", "targetProperty"]}
                rules={[
                  {
                    required: true,
                    message: "대상 부동산 주소를 입력해주세요",
                  },
                ]}
              >
                <Input placeholder="가처분 대상 부동산 주소를 입력하세요" />
              </Form.Item>

              <Form.Item
                label={
                  <>
                    명도소송 진행 여부
                    <Popover
                      content={
                        <div>
                          명도소송을 이미 제기했거나 준비 중인지
                          <br />
                          선택해주세요. 가처분은 명도소송과
                          <br />
                          함께 진행하는 것이 일반적입니다.
                        </div>
                      }
                      placement="bottom"
                      trigger="click"
                    >
                      <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                    </Popover>
                  </>
                }
                name={["injunction", "vacatehouseFiled"]}
                rules={[{ required: true, message: "" }]}
              >
                <Radio.Group>
                  <Radio.Button value="y">이미 진행 중</Radio.Button>
                  <Radio.Button value="preparing">준비 중</Radio.Button>
                  <Radio.Button value="n">아직 아님</Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Row justify="space-between">
                <Col span={6} offset={18} style={{ textAlign: "right" }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%", maxWidth: "100px" }}
                  >
                    다음
                  </Button>
                </Col>
              </Row>
            </Form>
          </CaseDetailWrapper>
        </ContentContainer>
      </MyCaseSection>
    </Container>
  );
};

export default Step1;
